<h5>
  {{ReleaseSource}} Release Log
  <small class="pull-right title-link">
    <button class="btn btn-link" *ngIf="userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'" mat-dialog-close (click)="fn_DismissReleaseNote()">Dismiss</button>
    <button class="btn btn-info" *ngIf="userRole === 'SuperAdmin' || userRole === 'CustomerService'" mat-dialog-close>Close</button>
  </small>
  <span class="clearfix"></span>
</h5>

<div class="release-content">
  <div *ngFor="let item of releaseNoteList;let first = first" class="release-section">
    <i *ngIf="(userRole === 'SuperAdmin' || userRole === 'CustomerService') && first" style="font-size: 25px;"
       (click)="fn_EditReleaseNote(item)" class="fa fa-pencil-square-o text-info" aria-hidden="true"></i>
    <small class="date-release-note">{{item.CreatedDate | date}}</small>
    <br />
    <br />
    <div [innerHTML]="item.ReleaseNote | safeHtml"></div>
  </div>
</div>
<div class="text-center">
  <button class="btn btn-default" (click)="fn_OlderRelese()" *ngIf="!HideNextLink">View older log</button>
</div>
